
import { computed, defineComponent, reactive, ref } from 'vue';
import { Coupon } from '@comsbi/common/src/types/models';
import { useShop } from '@/compositions/useShop';

/**
 * クーポン対象店舗一覧
 */
export default defineComponent<{ coupon: Coupon }>({
  name: 'CouponAvailableShops',

  props: {
    coupon: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const { getDetails } = useShop();

    const shops = ref<any>([]);

    const init = async () => {
      if (!props.coupon.shopIds || props.coupon.shopIds.length <= 0) return;
      shops.value = await getDetails(props.coupon.shopIds as string[]);
    };
    init();

    return {
      shops,

      hasShops: computed(() => {
        return props.coupon.shopIds && props.coupon.shopIds.length > 0;
      }),
    };
  },
});
